module.exports = __webpack_public_path__ + "static/img/postmaster.d9f3358.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/postmaster.jpg
// module id = z2hC
// module chunks = 1